/* @flow */

import React from 'react';
import { Col, Input, FormGroup, Label } from 'reactstrap';
import _ from 'lodash';

import { createHTMLMarkup, branch } from '../../utils';
import RevertInput from '../RevertInput';

import classes from './FieldRadioGroup.scss';
import fieldWrapperClases from '../FieldWrapper/FieldWrapper.scss';

type OptionsType = {
  display: string,
  key: string | number,
  name: string,
};

type PropsType = {
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string,
  error: string[],
  options: OptionsType[],
  revertInput: Function,
  value: number | string,
};

export class FieldRadioGroup extends React.Component<PropsType, *> {
  static defaultProps = {
    options: [],
    error: [],
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const hasError = this.props.error.length > 0;
    const options = this.props.options.map(
      (opt: OptionsType) => {
        // TODO: fix this intential == cast. Either all strings or handle numbers correctly?
        // $FlowFixMe
        const checked = opt.key == this.props.value; // eslint-disable-line eqeqeq
        return (
          <FormGroup check key={opt.key}>
            <Label check>
              <Input
                type="radio"
                value={opt.key}
                checked={checked}
                onChange={this.props.changeInput}
              />
              {' '}{createHTMLMarkup(opt.name || opt.display)}
            </Label>
          </FormGroup>
        );
      },
    );

    const canRevert = this.props.changed || this.props.value !== this.props.defaultVal;

    const getRevertNameFromValue: () => string = (): string => {
      const val = this.props.defaultVal;
      const opt: ?OptionsType = this.props.options.find(i => i.key === val);
      const short: string = _.get(opt, ['display']);
      const name: string = _.get(opt, ['name'], val);
      return short || name;
    };

    const recommendedDiv = (
      <RevertInput
        className={fieldWrapperClases.inputGroupDefault}
        value={getRevertNameFromValue()}
        enable={canRevert}
        onClick={this.props.revertInput}
      />
    );

    return (
      <Col sm={6}>
        <FormGroup tag="fieldset" className={classes.formGroup}>
          {options}
          { branch(hasError, <div className={fieldWrapperClases.errorBlock}>Error: {this.props.error}</div>, null) }
          <div className={fieldWrapperClases.inputGroupColumn}>
            {recommendedDiv}
          </div>
        </FormGroup>
      </Col>
    );
  }
}

export default FieldRadioGroup;



// WEBPACK FOOTER //
// ./src/components/FieldRadioGroup/FieldRadioGroup.js